import {getCookie, show} from './helpers';

window.firstTime = {
    setup: function () {
        //
        // Trigger First Time Elements
        //
        this.toggleFirstTimeElements();
    },

    /**
     * Toggle First Time Elements
     *
     * We show [data-first-time] under these conditions:
     * - There is a cookie set for first-time and it's value (a timestamp) is less than 24 hours old
     * - There is no cookie set for first-time
     *
     * The other scenario is where the cookie first-time is set but it's older then 24 hours
     */
    toggleFirstTimeElements() {
        let maximumTimeInSeconds = 1000 * 60 * 60 * 24 * 3; // 3 days

        if (window.firstTimeMaxDuration) {
            maximumTimeInSeconds = 0;
            maximumTimeInSeconds += 1000 * 60 * parseInt(window.firstTimeMaxDuration.minutes);
            maximumTimeInSeconds += 1000 * 60 * 60 * parseInt(window.firstTimeMaxDuration.hours);
            maximumTimeInSeconds += 1000 * 60 * 60 * 24 * parseInt(window.firstTimeMaxDuration.days);
        }

        if (window.authorisation.isVerified()) {
            let isSubscribedAudioAndVideo = window.authorisation.isSubscribed('subscription_audio_and_video');

            if (isSubscribedAudioAndVideo) {
                let firstTime = getCookie('first-time');
                let now = new Date();
                let showFirstTime = false;

                // Show first time if it's the first time
                if (firstTime) {
                    firstTime = parseInt(firstTime);

                    // console.log(now.getTime(), firstTime, now.getTime() - firstTime, maximumTimeInSeconds);
                    // console.log((now.getTime() - firstTime) < maximumTimeInSeconds);

                    if ((now.getTime() - firstTime) < maximumTimeInSeconds) {
                        console.log('showing first time');
                        showFirstTime = true;
                    }
                } else {
                    showFirstTime = true;
                    document.cookie = 'first-time=' + now.getTime() + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
                }

                //
                // Force if it's post checkout (?subscribe_success=true)
                //
                let isPostCheckout = (new URLSearchParams(window.location.search)).get('subscribe_success');
                if (isPostCheckout) {
                    showFirstTime = true;
                }

                if (showFirstTime) {
                    show('[data-first-time]');
                } else {
                    show('[data-not-first-time]');
                }
            }
        }
    },
}
